import styled from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'

const Input = styled.div`
  display: flex;

  & > *:first-child {
    margin-right: ${sv.spacing.xxsmall};
  }
`

export default { Input }
